module.exports = __webpack_public_path__ + "img/6.a2ac70a6.png";